import { type OpenDockLoadTypes } from '../domain/Shipment'

export function formatLoadTypeInfo(loadType: OpenDockLoadTypes) {
  return `${loadType.operation} - ${loadType.equipmentType} - ${loadType.mode} - ${loadType.duration}m`
}
